import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { AuthService } from '../../../../services/auth.service';
import { ReportableService } from '../../../../services/reportable.service';
import { Router, ActivatedRoute } from '@angular/router';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../../models/paging/page';
import { CylHistoryService } from '../../../../services/cyl-history.service';
import { ColumnService } from '../../../../services/ColumnService';
import { CheckUserType } from '../../../../models/checkUserType';


@Component({
  selector: 'app-cyl-history',
  templateUrl: './cyl-history.component.html',
  styleUrls: ['./cyl-history.component.css']
})
export class CylHistoryComponent implements OnInit {
  @Input() cylinder_Id: string;
  @Input() cylinder_Serial_No: string;
  role = new CheckUserType();
  client;
  page = new Page();
  rows = Array<any>();
  init: boolean;

  filter: any = {
    quick_Search: ''
  };

  authService: any;

  availableOptions: string[] = ['Date', 'Action', 'User', 'Batch #', 'Fill Expiry', 'Customer',
    'Account #', 'Location Address', 'Location Postcode', 'Collection Fault', 'Submitted Date & Time', 'Date & Time'];

  selectedOptions: string[] = ['Date', 'Action', 'User', 'Batch #', 'Customer',
    'Submitted Date & Time', 'Date & Time'];

  constructor(authService: AuthService, public cylHistoryService: CylHistoryService, public reportableService: ReportableService,
    public router: Router, private route: ActivatedRoute, public location: Location, private columnService: ColumnService) {
    this.client = authService.currentUser.value;
    this.role.initClient(this.client.role);
    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";
  }

  ngOnInit() {
    this.getcolumns();
    if (this.cylinder_Id != undefined) {
      this.loadTable();
      this.init = true;
    }
  }


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    const sortMapping = {
      'user': 'firstname',
      'movement_Date_With_Time': 'movement_DateTime_Sorting',
    };

    const sortBy = sortMapping[event.column.prop] || event.column.prop;
    this.page.sortOrder = event.newValue;
    this.page.sortBy = sortBy;
    this.loadTable();
  }

  loadTable() {
    this.cylHistoryService.getResults(this.page, parseInt(this.cylinder_Id), this.filter.quick_Search).then((pagedData) => {
      this.page = pagedData.page;
      this.rows = pagedData.data;

      for (let i = 0; i < this.rows.length; i++) {
        const movement_Date_With_Time = moment(this.rows[i].movement_Date_With_Time, "DD MMM YYYY");
        this.rows[i].movement_Date_With_Time = movement_Date_With_Time.format("DD/MM/YYYY");

        const submitted_Time = moment(this.rows[i].submitted_Time, "DD MMM YYYY hh:mm:ss");
        this.rows[i].submitted_Time = submitted_Time.format("DD/MM/YYYY hh:mm:ss");

        const movement_DateTime_Sorting = moment(this.rows[i].movement_DateTime_Sorting, "YYYY-MM-DD hh:mm:ss");
        this.rows[i].movement_DateTime_Sorting = movement_DateTime_Sorting.format("DD/MM/YYYY hh:mm:ss");
      }

      if (this.init) {
        this.gotoTop();
        this.init = false;
      }
    });
  }


  onRefresh() {
    this.page.pageNumber = 0;
    this.loadTable();
  }

  downloadReport(id: number) {
    this.reportableService.getDeliveryNotes(id).then((data) => {
      importedSaveAs(data, 'Delivery Notes.pdf');
    });
  }

  generateExcel() {
    this.cylHistoryService.getExcel(parseInt(this.cylinder_Id)).then((data) => {
      importedSaveAs(data, 'Cylinder_History_' + this.cylinder_Serial_No + '.xlsx');
    });
  }

  gotoTop() {
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView(true);
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "cylHistoryComponent").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }
    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "cylHistoryComponent", this.selectedOptions).then((data) => {
    });
  }
}
